import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderModule } from '@shared/loader/loader.module';

@NgModule({
  imports: [TranslateModule, CommonModule, LoaderModule],
  declarations: [],
  exports: [TranslateModule, LoaderModule],
})
export class SharedModule {}
